/** Kept across logout / session expiry: the side menu's "last seen" marks (NavDotsService). */
const KEEP_PREFIX = "fh-admin-seen-";

/** localStorage.clear(), except the nav-dot "seen" marks, so the dots don't reset on logout. */
export const clearLocalStorageUtil = () => {
  try {
    const kept: [string, string][] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith(KEEP_PREFIX)) kept.push([key, localStorage.getItem(key) ?? ""]);
    }
    localStorage.clear();
    for (const [key, value] of kept) localStorage.setItem(key, value);
  } catch {
    // Blocked storage: nothing to clear.
  }
};
